import { Outlet } from 'react-router-dom'
import { Brain, Sparkles, Target } from 'lucide-react'

export default function AuthLayout() {
  return (
    <div className="min-h-screen flex">
      {/* Left Panel - Branding and Features */}
      <div className="hidden lg:flex lg:w-1/2 xl:w-2/5 bg-gradient-to-br from-tutara-primary via-tutara-secondary to-tutara-primary-dark relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-black/10"></div>
          <div className="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full filter blur-3xl transform -translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-tutara-primary-light/20 rounded-full filter blur-3xl transform translate-x-1/2 translate-y-1/2"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 flex flex-col justify-between p-12 text-white">
          {/* Logo */}
          <div>
            <img 
              src="/logos/logo-white.png" 
              alt="Tutara" 
              className="h-12 w-auto"
            />
          </div>

          {/* Main Content */}
          <div className="space-y-8">
            <div>
              <h1 className="text-4xl xl:text-5xl font-bold mb-4">
                Learn Your Way to Success
              </h1>
              <p className="text-xl text-white/90">
                AI-powered personalized learning that adapts to your unique style and pace
              </p>
            </div>

            {/* Feature List */}
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 rounded-lg bg-white/20 backdrop-blur-sm flex items-center justify-center">
                  <Brain className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="font-semibold">Adaptive Learning Paths</h3>
                  <p className="text-sm text-white/80">Customized curriculum based on your skills and goals</p>
                </div>
              </div>

              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 rounded-lg bg-white/20 backdrop-blur-sm flex items-center justify-center">
                  <Sparkles className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="font-semibold">AI-Powered Insights</h3>
                  <p className="text-sm text-white/80">Smart recommendations to accelerate your progress</p>
                </div>
              </div>

              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 rounded-lg bg-white/20 backdrop-blur-sm flex items-center justify-center">
                  <Target className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="font-semibold">Goal-Oriented Learning</h3>
                  <p className="text-sm text-white/80">Stay focused with clear milestones and achievements</p>
                </div>
              </div>
            </div>

            {/* Platform Highlights */}
            <div className="grid grid-cols-3 gap-4 pt-8 border-t border-white/20">
              <div>
                <div className="text-2xl font-bold">Personalized</div>
                <div className="text-sm text-white/80">AI adapts to you</div>
              </div>
              <div>
                <div className="text-2xl font-bold">Adaptive</div>
                <div className="text-sm text-white/80">Learn at your pace</div>
              </div>
              <div>
                <div className="text-2xl font-bold">Smart</div>
                <div className="text-sm text-white/80">Built with AI</div>
              </div>
            </div>
          </div>

          {/* Value Proposition */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
            <p className="text-sm italic mb-3">
              Upload your resume, and our AI builds a learning path tailored to your skills, goals, and interests — with analogies that make complex concepts click.
            </p>
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                <Sparkles className="w-5 h-5" />
              </div>
              <div>
                <p className="text-sm font-semibold">Powered by Advanced AI</p>
                <p className="text-xs text-white/70">Personalized learning, reimagined</p>
              </div>
            </div>
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg className="w-full text-white/5" viewBox="0 0 1440 320" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,138.7C960,139,1056,117,1152,106.7C1248,96,1344,96,1392,96L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
          </svg>
        </div>
      </div>

      {/* Right Panel - Auth Forms */}
      <div className="flex-1 flex items-center justify-center bg-gray-50 dark:bg-tutara-dark-mode-bg">
        <div className="w-full">
          <Outlet />
        </div>
      </div>
    </div>
  )
}